import { useEffect, useState, useCallback } from "react";
import { IAdvertisementText } from "types/advertisement";

interface TextSliderProps {
  texts: IAdvertisementText[];
  className?: string;
}

const TextSlider = ({ texts, className = "" }: TextSliderProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const sortedTexts = [...texts].sort((a, b) => a.order - b.order);

  const goToNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % sortedTexts.length);
  }, [sortedTexts.length]);

  useEffect(() => {
    if (sortedTexts.length <= 1) return;

    const currentText = sortedTexts[currentIndex];
    const duration = currentText?.duration || 5000;

    const timer = setTimeout(goToNext, duration);

    return () => clearTimeout(timer);
  }, [currentIndex, sortedTexts, goToNext]);

  if (sortedTexts.length === 0) {
    return (
      <div className={`flex items-center justify-center bg-gray-50 ${className}`}>
        <span className="text-gray-400">No content</span>
      </div>
    );
  }

  const currentText = sortedTexts[currentIndex];

  return (
    <div className={`overflow-auto ${className}`}>
      <div
        key={currentText.id}
        className="w-full h-full p-4 transition-opacity duration-500 ad-text-content"
        dangerouslySetInnerHTML={{ __html: currentText.content }}
      />
    </div>
  );
};

export default TextSlider;
